/**
 * Goes on an outlined card that isn't clicked as a whole. The theme rings
 * every outlined card on hover, which would promise a click that does nothing.
 */
export const staticCardSx = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '&:hover': {
    outlineColor: 'transparent'
  }
} as const;